var map = {
	"./agenda/index.js": 970,
	"./flow/minimal/index.js": 973,
	"./flow/rgpd/index.js": 976,
	"./flow/simple/index.js": 980,
	"./gallery/index.js": 986,
	"./home/index.js": 313,
	"./myspace/index.js": 992,
	"./nav/simple/index.js": 1001,
	"./news/simple/index.js": 1003,
	"./pdf/index.js": 1006,
	"./surveys-list/index.js": 1009,
	"./video/index.js": 1012,
	"./web/index.js": 1015,
	"./youtube/index.js": 1018
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2170;


//////////////////
// WEBPACK FOOTER
// ./src/modules/catalog/plugins ^\.\/.*\/index\.js$
// module id = 2170
// module chunks = 0